import { create } from "jss";
import rtl from "jss-rtl";
import React from "react";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { StylesProvider } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

// Configure JSS
const jss = create();
jss.use(rtl());

// MUI v5 generated styles are emitted by Emotion, not JSS.
// The RTL cache flips generated physical rules like Stack's margin-left spacing.
const rtlCache = createCache({
  key: "mui-rtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const theme = createTheme({
  direction: "rtl",
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          transform: "scaleX(-1)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          marginLeft: 16,
          marginRight: 16,
        },
        startIcon: {
          transform: "scaleX(-1)",
          marginLeft: 4,
        },
        endIcon: {
          transform: "scaleX(-1)",
          marginLeft: 8,
          marginRight: 8,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          "& .MuiSvgIcon-root": {
            transform: "scaleX(-1)",
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          transform: "scaleX(-1)",
        },
      },
    },
  },
});

function RTL(props) {
  if (!props.isRTL) return <>{props.children}</>;

  return (
    <>
      <CacheProvider value={rtlCache}>
        <StylesProvider jss={jss}>
          <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
        </StylesProvider>
      </CacheProvider>
    </>
  );
}

export default RTL;
